import {Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef} from "@angular/core";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {DeviceDetectService} from "../../services/device-detect.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { NgClass, NgTemplateOutlet } from "@angular/common";
import {PageContentHeaderComponent} from "../components/page-content-header/page-content-header.component";


export interface Info {
  modalHeader?: string;
  selectedOption?: string;
  option1: string;
  option1text: string;
  option2?: string;
  option2text?: string;
}

@Component({
  selector: "app-info-modal",
  templateUrl: "./info-modal.component.html",
  styleUrls: ["./info-modal.component.css"],
  imports: [
    NgClass,
    NgTemplateOutlet,
    TranslateModule,
    PageContentHeaderComponent
]
})
export class InfoModalComponent implements OnInit {

  showModal: boolean;
  disappear: boolean;
  showButtons: boolean = true;
  @Input() info: Info;
  @Input() modalTemplate: TemplateRef<any>;
  @Input() rateInfo: {};
  @Output() closeModal = new EventEmitter<void>();
  rateExplanations: [rate: string];
  @Input() modalParagraphs: string[];

  splitText: Array<string> = [];
  isMobile: boolean;

  constructor(private deviceDetect: DeviceDetectService,
              private dialogRef: MatDialogRef<InfoModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private translate: TranslateService,
  ) {
    this.isMobile = deviceDetect.isMobile;
  }

  ngOnInit(): void {
    this.modalTemplate = this.data;
    setTimeout(() => {
      this.showModal = true;
    }, 1000);
    setTimeout(() => {
      this.disappear = false;
    }, 1000);
    this.listAllRatesInfo();
  }

  listAllRatesInfo() {
    this.translate.get("generalFeedback.explanation")
      .subscribe((data) => {
        this.rateExplanations = data;
      });
  }

  onClose() {
    this.dialogRef.close();
    this.closeModal.emit();
    this.disappear = true;
  }
}
